// #363 — a group's site drawing and its pins, shared by the map window's site view and the Groups page dialog (one
// cache entry per group). `data` is null when the group has no drawing (the API's 404).
import { useQuery } from '@tanstack/react-query'
import { sitePlansApi } from '@/api/endpoints'
import { queryKeys, queryOptions } from '@/config/queryConfig'

export function useSitePlan(groupId: number, enabled = true) {
  return useQuery({
    queryKey: queryKeys.sitePlans.group(groupId),
    queryFn: ({ signal }) => sitePlansApi.get(groupId, signal),
    enabled,
    ...queryOptions.sitePlans.group,
  })
}

/** The API's reason for a refused request: {"detail": "..."} or the first message of a field error. */
export function sitePlanError(error: unknown): string | null {
  const data = (error as { response?: { data?: unknown } } | null)?.response?.data
  if (!data || typeof data !== 'object') return null
  const d = data as Record<string, unknown>
  if (typeof d.detail === 'string' && d.detail) return d.detail
  for (const field of ['image', 'members_can_arrange', 'pins', 'non_field_errors']) {
    const first = firstMessage(d[field])
    if (first) return first
  }
  return null
}

// A field error is a list of strings, or (DRF, for a list of objects) a list of objects of lists.
function firstMessage(value: unknown): string | null {
  if (typeof value === 'string') return value || null
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = firstMessage(item)
      if (found) return found
    }
    return null
  }
  if (value && typeof value === 'object') {
    for (const item of Object.values(value as Record<string, unknown>)) {
      const found = firstMessage(item)
      if (found) return found
    }
  }
  return null
}
